// extracted by mini-css-extract-plugin
module.exports = {"header":"OpportunityCriteriaFields_header__2ZV18","heading":"OpportunityCriteriaFields_heading__3G30Z","hint":"OpportunityCriteriaFields_hint__2Xc55"};